// extracted by mini-css-extract-plugin
export default {"Select":"Settings_Select__GLrR0","SettingsContent":"Settings_SettingsContent__90BzF","Ability":"Settings_Ability__ZkSdq","Brand":"Settings_Brand__Z8zrO","Gap":"Settings_Gap__iqn8h"};